export const GET_ALL_MARKUPS_REQUEST = 'MARKUPS/GET_ALL_MARKUPS_REQUEST';
export const GET_ALL_MARKUPS_SUCCESS = 'MARKUPS/GET_ALL_MARKUPS_SUCCESS';
